import {
  createContext,
  useContext,
  useEffect,
  useRef,
  type ReactNode,
} from "react"
import { WheelEngine } from "./WheelEngine"

const WheelEngineContext = createContext<WheelEngine | null>(null)

export function WheelEngineProvider({ children }: { children: ReactNode }) {
  const engineRef = useRef<WheelEngine | null>(null)

  // After HMR / provider remount, ref can still point at a torn-down engine until effect cleanup runs.
  if (!engineRef.current || engineRef.current.isTornDown()) {
    engineRef.current = new WheelEngine()
  }

  useEffect(() => {
    const engine = engineRef.current
    return () => {
      engine?.destroy()
      engineRef.current = null
    }
  }, [])

  return (
    <WheelEngineContext.Provider value={engineRef.current}>
      {children}
    </WheelEngineContext.Provider>
  )
}

export function useWheelEngine(): WheelEngine | null {
  return useContext(WheelEngineContext)
}
